<div class="table-fms">
  <table>
    <thead>
      <tr>
        <th>
          <app-three-dots-menu [matMenuTriggerFor]="menu"></app-three-dots-menu>
          <mat-menu #menu="matMenu">
            <ul class="list">
              <app-drop-down-item class="width-100pcnt"
                data-qa="companies-export-excel"
                [iconNameAndStyling]="'excel.svg'"
                [text]="'Export'"
                (click)="exportExcel()">
              </app-drop-down-item>
            </ul>
            </mat-menu>
        </th>
        <th *ngFor="let header of headers let i = index"
          appSort
          [arr]="[industries]"
          [keySelector]="sortMap[i]">
          {{header}}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let industry of industries">
        <td></td>
        <td>{{industry.sector}}</td>
        <td>{{industry.amountOfCompanies | number:'1.0-0'}}</td>
        <td>
          <span *ngIf="industry.costYear1">
            {{industry.costYear1 | number:'1.0-0'}}
          </span>
        </td>
        <td>
          <span *ngIf="industry.costYear2">
            {{industry.costYear2 | number:'1.0-0'}}
          </span>
        </td>
        <td>
          <span *ngIf="industry.fmvYear1">
            {{industry.fmvYear1 | number:'1.0-0'}}
          </span>
        </td>
        <td>
          <span *ngIf="industry.fmvYear2">
            {{industry.fmvYear2 | number:'1.0-0'}}
          </span>
        </td>
        <td>
          <span *ngIf="industry.totalRoundYear1">
            {{industry.totalRoundYear1 | number:'1.0-0'}}
          </span>
        </td>
        <td>
          <span *ngIf="industry.totalRoundYear2">
            {{industry.totalRoundYear2 | number:'1.0-0'}}
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
